// ─── Progression d'apprentissage (Core) — porté de MoPCal ─────────
// Stockée sur users/{uid}.apprentissage = { mep: { [cle]: true }, tutos: { [cle]: true } }.
// Écriture du PROPRE doc utilisateur. `cle` contient un point
// (« calendrier.premierEvenement ») : setDoc/merge avec objet imbriqué → la clé
// pointée reste une clé littérale (pas un chemin).
import { db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

export async function marquerMePFaite(uid, cle) {
  if (!uid || !cle) return;
  await setDoc(doc(db, 'users', uid), { apprentissage: { mep: { [cle]: true } } }, { merge: true });
}

export async function marquerTutoVu(uid, cle) {
  if (!uid || !cle) return;
  await setDoc(doc(db, 'users', uid), { apprentissage: { tutos: { [cle]: true } } }, { merge: true });
}

export async function lireApprentissage(uid) {
  if (!uid) return { mep: {}, tutos: {} };
  try {
    const s = await getDoc(doc(db, 'users', uid));
    const a = s.exists() ? (s.data().apprentissage || {}) : {};
    return { mep: a.mep || {}, tutos: a.tutos || {} };
  } catch { return { mep: {}, tutos: {} }; }
}
